import { observer } from 'mobx-react';
import React, { Component, DragEvent } from 'react';
import TubesViewModel from 'stores/models/TestTubeRack';
import { DragAndDropTypes } from 'stores/models/types';
import TestTubeRack from './TestTubeRack';
import {
  isValidDragEvent,
  onDragOver,
  stopAndPrevent,
} from './utils/EventUtils';

interface IProps {
  onDropSuccess: () => void;
  model?: TubesViewModel | null;
}

interface IState {
  hasDropped: boolean;
  isDropReady: boolean;
}

class View extends Component<IProps, IState> {
  defaultState: IState = { hasDropped: false, isDropReady: false };

  constructor(props: IProps) {
    super(props);

    this.state = this.defaultState;
  }

  public reset = () => {
    this.setState(this.defaultState);
  };

  private onDragEnter = (e: DragEvent<HTMLDivElement>): void => {
    if (isValidDragEvent(e, DragAndDropTypes.Ecoli)) {
      stopAndPrevent(e);
      this.setState({ isDropReady: true });
    }
  };

  private onDragLeave = (e: DragEvent<HTMLDivElement>): void => {
    if (isValidDragEvent(e, DragAndDropTypes.Ecoli)) {
      stopAndPrevent(e);
      this.setState({ isDropReady: false });
    }
  };

  private onDrop = (e: DragEvent<HTMLDivElement>): void => {
    if (isValidDragEvent(e, DragAndDropTypes.Ecoli)) {
      const { onDropSuccess } = this.props;

      this.setState({ hasDropped: true, isDropReady: false });

      onDropSuccess();

      stopAndPrevent(e);
    }
  };

  render() {
    const { model } = this.props;
    const { hasDropped, isDropReady } = this.state;

    const styleDrop = model && hasDropped ? 'has-dropped' : '';
    const styleDropReady = isDropReady ? 'is-drop-ready' : '';

    return (
      <div className='is-flex is-align-items-center'>
        <div
          className={`ecoli-drop-target has-text-centered is-unselectable ${styleDropReady} ${styleDrop}`}
          onDragEnter={this.onDragEnter}
          onDragLeave={this.onDragLeave}
          onDragOver={onDragOver}
          onDrop={this.onDrop}
        >
          <div className='ecoli-drop-target-gfx is-pointerless'>
            <TestTubeRack model={model} />
          </div>
        </div>
      </div>
    );
  }
}

const EcoliDropTarget = observer(View);
export default EcoliDropTarget;
